<template>
    <div>
        <div class="row">
            <div class="col-sm-3">
                <div class="card widget-1">
                    <div class="card-body">
                        <div class="widget-content">
                            <div class="widget-round info">
                                <div class="bg-round">
                                    <svg class="svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#fill-user`"></use>
                                    </svg>
                                    <svg class="half-circle svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#halfcircle`"></use>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <h4>{{ employee ? $formatDate(employee.initial_date+"") : '' }}</h4>
                                <span class="f-light">
                                    Fecha de Alta
                                </span>
                            </div>
                        </div>
                        <div class="font-secondary f-w-500"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card widget-1">
                    <div class="card-body">
                        <div class="widget-content">
                            <div class="widget-round secondary">
                                <div class="bg-round">
                                    <svg class="svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#fill-calender`"></use>
                                    </svg>
                                    <svg class="half-circle svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#halfcircle`"></use>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <h4>{{ employee ? (employee.work_age - 1) : '' }} {{ employee ? ((employee_work_age - 1) == 1 ? ' año' : 'años') : '' }}</h4>
                                <span class="f-light">
                                    Antigüedad Laboral
                                </span>
                            </div>
                        </div>
                        <div class="font-secondary f-w-500"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card widget-1">
                    <div class="card-body">
                        <div class="widget-content">
                            <div class="widget-round primary">
                                <div class="bg-round">
                                    <svg class="svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#24-hour`"></use>
                                    </svg>
                                    <svg class="half-circle svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#halfcircle`"></use>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <h4>{{ available_days }} {{ available_days != 1 ? 'días' : 'día' }}</h4>
                                <span class="f-light">
                                    Vacaciones Disponibles
                                </span>
                            </div>
                        </div>
                        <div class="font-secondary f-w-500"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="card widget-1">
                    <div class="card-body">
                        <div class="widget-content">
                            <div class="widget-round success">
                                <div class="bg-round">
                                    <svg class="svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#profile-check`"></use>
                                    </svg>
                                    <svg class="half-circle svg-fill">
                                        <use :xlink:href="require('@/assets/svg/icon-sprite.svg') + `#halfcircle`"></use>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <h4>{{ taken_days }} {{ taken_days != 1 ? 'días' : 'día' }}</h4>
                                <span class="f-light">
                                    Vacaciones Disfrutadas
                                </span>
                            </div>
                        </div>
                        <div class="font-secondary f-w-500"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <VacationsTable ref="vacationsTable" @refresh="refreshData" />
            </div>
        </div>
    </div>
</template>
<script>

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import VacationsTable from "@/components/tmkt/employees/vacations_table.vue"

import ws from '@/services/employees'

export default {
    name: 'employee_contract_tab',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker,
        VacationsTable
    },
    data(){
        return{
            employee: null,
            employers: [],
            job_positions: [],
            bosses: [],
            available_days: 0,
            taken_days: 0
        }
    },
    methods: {
        async loadEmployee(employee){
            this.employee = employee;

            let response = await ws.getEmployers(); 

            if(response.type == "success"){
                this.employers = response.data;
            }

            let response2 = await ws.getPositions(); 

            if(response2.type == "success"){
                this.job_positions = response2.data;
            }

            let response3 = await ws.getBosses(); 

            if(response3.type == "success"){
                this.bosses = response3.data;
            }

            this.$refs.vacationsTable.loadEmployee(employee);

            this.setForm(this.employee);
        },
        async refreshData(data) {
            this.available_days = data.available_days;
            this.taken_days = data.taken_days;
        },
        validations(){
            this.updateEmployeeContractValidation();
        }
    }
}
</script>
<style>
    .dp2{
        input {
            height: 28px;
        }
    }
</style>

<style scoped>
    .container-fluid {
        padding-top: 20px;
    }

    .title{
        font-size: 28px;
    }

    .datepicker-here{
        padding: 0.25rem 0.75rem;
    }

    .rest_days{
        margin-left: 10px;
        float: left;
    }

    .rest_days td{
        padding-right: 8px;
        text-align: center;
    }

    .rest_days th{
        padding-right: 8px;
        text-align: left;
    }

    .infonavit td{
        text-align: center;
    }
</style>